import { Tooltip } from "antd";
import { FolderOpenFilled } from "@ant-design/icons";

const Columns = (handleOpenChangeLog, filters) => {
  return [
    {
      title: "Nombre",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '15%',
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#FDE2E2",
          color: "#B22222",
          fontWeight: "bold",
        },
      }),
      showSorterTooltip: false,
      width: "20%",
    },
    {
      title: "Riesgo",
      dataIndex: "risk",
      key: "risk",
      sorter: (a, b) => (a.risk?.name || '').localeCompare(b.risk?.name || ''),
      render: (text, record) => record.risk?.name || 'N/A',
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '8%',
    },
    {
      title: "Categoría",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category?.name || '').localeCompare(b.category?.name || ''),
      filterSearch: true,
      filters: filters.categories.map(cat => ({
        text: cat.name,
        value: cat.name
      })),
      onFilter: (value, record) => record.category?.name === value,
      render: (text, record) => record.category?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '10%',
    },    
    {
      title: "Tipo",
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => (a.type?.name || '').localeCompare(b.type?.name || ''),
      filters: filters.types.map(t => ({
        text: t.name,
        value: t.name
      })),
      //filteredValue: filters.dashboardTypeFilter ? [filters.dashboardTypeFilter] : undefined,
      defaultFilteredValue: filters.filteredTypeValue,
      onFilter: (value, record) => record.type?.name === value,
      render: (type) => type?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '8%',
    },
    {
      title: "Prioridad",
      dataIndex: "priority",
      key: "priority",
      sorter: (a, b) => (a.priority?.name || '').localeCompare(b.priority?.name || ''),
      filters: filters.priorities.map(p => ({
        text: p.name,
        value: p.name
      })),
      //filteredValue: filters.dashboardPriorityFilter ? [filters.dashboardPriorityFilter] : undefined,
      defaultFilteredValue: filters.filteredPriorityValue,
      onFilter: (value, record) => record.priority?.name === value,
      render: (priority) => priority?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      width: '10%',
      align: 'center',
    },
    {
      title: "Responsable",
      dataIndex: "area",
      key: "area",
      sorter: (a, b) =>
        (a.area?.name || "").localeCompare(b.area?.name || ""),
      render: (_, record) => record.area?.name || "N/A",
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#FDE2E2",
          color: "#B22222",
          fontWeight: "bold",
        },
      }),
      showSorterTooltip: false,
      width: "15%",
    },
    {
      title: "Framework",
      dataIndex: "framework",
      key: "framework",
      sorter: (a, b) => (a.framework?.name || '').localeCompare(b.framework?.name || ''),
      filters: filters.frameworks.map(fw => ({
        text: fw.name,
        value: fw.name
      })),
      filterSearch: true,
      onFilter: (value, record) => record.framework?.name === value,
      render: (text, record) => record.framework?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '15%',
    },
    {
      title: "Log",
      dataIndex: "log",
      key: "log",
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } 
      }),
      width: '5%',
      render: (_, record) => (
        <div style={{ textAlign: 'center' }}>
          <Tooltip title="Ver Log">
            <FolderOpenFilled 
              style={{ fontSize: 20, cursor: 'pointer', color: '#B22222' }}
              onClick={() => handleOpenChangeLog(record)}
            />
          </Tooltip>
        </div>
      )
    }
  ];
};

export default Columns;
